import React from "react";
import Canvas from "../../../components/Canvas";

const HeroSection = ({ count }) => {
  return (
    <section className="page-hero">
      <Canvas />
      <div className="container page-hero-grid">
        <div>
          <p className="eyebrow">Careers</p>
          <h1>Join Us</h1>
          <p className="hero-copy">
            Build your career with us and work with leading companies in the
            United States.
          </p>
        </div>
        <div className="page-hero-media">
          <section className="card careers-hero-card">
            <span>Open roles</span>
            <strong>{count}</strong>
            <p>Current opportunities available through Lovapex Tech.</p>
          </section>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
